var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobCrossPilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bcbcbc;}.cls-2{fill:#777;}.cls-3{fill:#e8e8e8;}.cls-4{fill:#301d29;}.cls-5{fill:#5b4956;}.cls-6{fill:#12b0e0;}.cls-7{fill:#cecece;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "279.5 286.5 0.5 286.5 2.5 247.5 6.49 226.65 140 207.5 273.51 226.65 277.5 247.5 279.5 286.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "251.79 265.2 28.21 265.2 1.56 191.86 42.03 134.63 72.44 158.89 207.56 158.89 237.97 134.63 278.44 191.86 251.79 265.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "221.43 66.08 179.75 22.66 101.86 22.66 60.18 66.08 57.29 145.66 70.38 213.84 107.12 213.84 174.49 213.84 211.23 213.84 224.32 145.66 221.43 66.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "258.07 319.75 22.79 319.75 5.11 222.46 140.43 208.35 275.75 222.46 258.07 319.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "154.85 57.13 126.01 57.13 75.18 88.55 71.08 148.58 78.61 212.45 118.21 236.33 162.65 236.33 202.09 212.45 209.78 130.89 205.68 88.55 154.85 57.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "64.7 188.54 111.08 176.04 132.82 194.51 119.25 212.21 112.93 241.99 100.79 230.5 77.31 203.78 64.7 188.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "217.31 150.49 188.71 176.73 167.94 164.76 140.81 158.92 113.83 164.76 92.55 176.73 63.55 150.49 67.94 111.14 140.43 65.7 212.92 111.14 217.31 150.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "184.31 124.62 140.76 114.64 97.45 124.62 61.79 105.65 140.43 30.73 219.06 105.65 184.31 124.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "214.89 188.54 173.78 177.05 147.66 194.51 161.23 212.21 167.55 241.99 179.69 230.5 203.21 203.78 214.89 188.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "223.95 61.14 180.45 15.88 100.41 15.88 56.91 61.14 53.91 142.94 67.48 213.56 80.1 213.56 65.86 156.72 80.71 108.15 114.51 79.39 166.35 79.39 200.15 108.15 215 156.72 200.76 213.56 213.38 213.56 226.95 142.94 223.95 61.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "208.41 261.25 140.5 272.5 72.45 261.25 19.76 200.96 27.92 174.89 71.92 189.15 99.39 226.09 140.43 238.76 181.47 226.09 208.94 189.15 252.94 174.89 261.1 200.96 208.41 261.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "163.97 79.39 116.28 79.39 101.08 14.71 179.18 14.71 163.97 79.39"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobCrossPilot);
export default __webpack_public_path__ + "static/media/mob-cross-pilot.e0408a881604298465dd63da39c2da4b.svg";
export { ForwardRef as ReactComponent };